export default function SectionHeading({
  kicker,
  title,
  desc,
  align = 'left',
  center,
}: {
  kicker: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  center?: boolean;
}) {
  const alignCls = align === 'center' || center ? 'items-center text-center mx-auto' : 'items-start';
  return (
    <div className={`flex flex-col ${alignCls} mb-8 md:mb-10`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
        <i className="ri-sparkling-2-fill h-3.5 w-3.5" />
        {kicker}
      </span>
      <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">{title}</h2>
      {desc ? (
        <p className={`mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${center ? 'mx-auto' : ''}`}>{desc}</p>
      ) : null}
    </div>
  );
}